import React, { Component } from "react";
import { Link } from "react-router-dom";
import ScrollableAnchor from "react-scrollable-anchor";
import intl from "react-intl-universal";
import { configureAnchors } from "react-scrollable-anchor";
import "./pricing.css";

class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      handle_buy_error: false,
      handle_buy_error_message: "",
      extenstion_single_User_checkbox: false,
      extension_small_Business_checkbox: false,
      extension_Enterprise_checkbox: false,
      single_user_packages: [
        {
          package_id: "110",
          package_time: intl.get("pricing_Yearly"),
          package_price: "1000"
        },
        {
          package_id: "111",
          package_time: intl.get("pricing_Monthly"),
          package_price: "100"
        }
      ],
      small_business_packages: [
        {
          package_id: "113",
          package_time: intl.get("pricing_Yearly"),
          package_price: "5000"
        },
        {
          package_id: "115",
          package_time: intl.get("pricing_Monthly"),
          package_price: "500"
        }
      ],
      enterprise_packages: [
        {
          package_id: "117",
          package_time: intl.get("pricing_Yearly"),
          package_price: "25000"
        },
        {
          package_id: "119",
          package_time: intl.get("pricing_Monthly"),
          package_price: "2500"
        }
      ],
      single_user_selected: {
        package_price: "1000",
        package_time: intl.get("pricing_Yearly"),
        package_id: "110"
      },
      small_business_selected: {
        package_price: "5000",
        package_time: intl.get("pricing_Yearly"),
        package_id: "113"
      },
      enterpriser_selected: {
        package_price: "25000",
        package_time: intl.get("pricing_Yearly"),
        package_id: "117"
      }
    };

    configureAnchors({ offset: -200, scrollDuration: 0 });
  }

  componentDidMount() {
    var regExp = /[?&]checkoutPlanId[=]([^&]+)(&|$)/gi;
    var match = regExp.exec(window.location.search);
    if (match != null) {
      this.fetchBuyNow(match[1]);
    }
  }

  selectedSingleUserChanged = event => {
    this.setSingleUserSelected(
      event.target.checked
        ? intl.get("pricing_Monthly")
        : intl.get("pricing_Yearly"),
      this.state.extenstion_single_User_checkbox
    );
  };

  extenstion_single_User_checkbox_changed = event => {
    this.setState({
      extenstion_single_User_checkbox: event.target.checked
    });

    this.setSingleUserSelected(
      this.state.single_user_selected.package_time,
      event.target.checked
    );
  };

  setSingleUserSelected = (package_time, extensionIncluded) => {
    var selected_package = {};
    if (extensionIncluded) {
      if (package_time === intl.get("pricing_Yearly")) {
        selected_package.package_id = "109";
        selected_package.package_time = intl.get("pricing_Yearly");
        selected_package.package_price = "2500"; // If Yearly and extension included
      } else {
        selected_package.package_id = "112";
        selected_package.package_time = intl.get("pricing_Monthly");
        selected_package.package_price = "250"; // If mothly and extension included
      }
    } else {
      // Extension not included
      if (package_time === intl.get("pricing_Yearly")) {
        selected_package.package_id = "110";
        selected_package.package_time = intl.get("pricing_Yearly");
        selected_package.package_price = "1000"; // If Yearly without extension
      } else {
        selected_package.package_id = "111";
        selected_package.package_time = intl.get("pricing_Monthly");
        selected_package.package_price = "100"; // If mothly without extension
      }
    }

    this.setState({
      single_user_selected: {
        package_price: selected_package.package_price,
        package_time: selected_package.package_time,
        package_id: selected_package.package_id
      }
    });
  };

  selectedSmallBusinessChanged = event => {
    this.setSmallBusinessSelected(
      event.target.checked
        ? intl.get("pricing_Monthly")
        : intl.get("pricing_Yearly"),
      this.state.extension_small_Business_checkbox
    );
  };

  extenstion_small_business_checkbox_changed = event => {
    this.setState({
      extension_small_Business_checkbox: event.target.checked
    });

    this.setSmallBusinessSelected(
      this.state.small_business_selected.package_time,
      event.target.checked
    );
  };

  setSmallBusinessSelected = (package_time, extensionIncluded) => {
    var selected_package = {};
    if (extensionIncluded) {
      if (package_time === intl.get("pricing_Yearly")) {
        selected_package.package_id = "114";
        selected_package.package_time = intl.get("pricing_Yearly");
        selected_package.package_price = "8000"; // If Yearly and extension included
      } else {
        selected_package.package_id = "116";
        selected_package.package_time = intl.get("pricing_Monthly");
        selected_package.package_price = "800"; // If mothly and extension included
      }
    } else {
      // Extension not included
      if (package_time === intl.get("pricing_Yearly")) {
        selected_package.package_id = "113";
        selected_package.package_time = intl.get("pricing_Yearly");
        selected_package.package_price = "5000"; // If Yearly without extension
      } else {
        selected_package.package_id = "115";
        selected_package.package_time = intl.get("pricing_Monthly");
        selected_package.package_price = "500"; // If mothly without extension
      }
    }

    this.setState({
      small_business_selected: {
        package_price: selected_package.package_price,
        package_time: selected_package.package_time,
        package_id: selected_package.package_id
      }
    });
  };

  selectedEnterpriseChanged = event => {
    this.setEnterpriseSelected(
      event.target.checked
        ? intl.get("pricing_Monthly")
        : intl.get("pricing_Yearly"),
      this.state.extension_Enterprise_checkbox
    );
  };

  extenstion_enterprise_checkbox_changed = event => {
    this.setState({
      extension_Enterprise_checkbox: event.target.checked
    });

    this.setEnterpriseSelected(
      this.state.enterpriser_selected.package_time,
      event.target.checked
    );
  };

  setEnterpriseSelected = (package_time, extensionIncluded) => {
    var selected_package = {};
    if (extensionIncluded) {
      if (package_time === intl.get("pricing_Yearly")) {
        selected_package.package_id = "118";
        selected_package.package_time = intl.get("pricing_Yearly");
        selected_package.package_price = "32000"; // If Yearly and extension included
      } else {
        selected_package.package_id = "120";
        selected_package.package_time = intl.get("pricing_Monthly");
        selected_package.package_price = "3200"; // If mothly and extension included
      }
    } else {
      // Extension not included
      if (package_time === intl.get("pricing_Yearly")) {
        selected_package.package_id = "117";
        selected_package.package_time = intl.get("pricing_Yearly");
        selected_package.package_price = "25000"; // If Yearly without extension
      } else {
        selected_package.package_id = "119";
        selected_package.package_time = intl.get("pricing_Monthly");
        selected_package.package_price = "2500"; // If mothly without extension
      }
    }

    this.setState({
      enterpriser_selected: {
        package_price: selected_package.package_price,
        package_time: selected_package.package_time,
        package_id: selected_package.package_id
      }
    });
  };

  handleBuyNow = (event, planID, isFreeTrialSelected) => {
    event.preventDefault();
    this.fetchBuyNow(planID, isFreeTrialSelected);
  };

  fetchBuyNow = (planID, isFreeTrialSelected) => {
    this.setState({ isLoading: true });

    if (this.props.props.isLoggedIn) {
      var testFlag = window.location.search.match(/[?&]test[=]1/gi) !== null;
      fetch(
        process.env.REACT_APP_API_URL +
          "CheckoutPlan?planId=" +
          planID +
          (testFlag ? "&test=1" : ""),
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
        .then(res => {
          if (res.ok) {
            return res;
          } else {
            throw Error(`Request rejected with status ${res.status}`);
          }
        })
        .then(res => res.json())
        .then(result => {
          if (result.Result.toLowerCase() === "success") {
            window.location = result.RedirectUrl;
          } else {
            this.setState({ handle_buy_error: true });
            this.setState({ handle_buy_error_message: result.Message });
            this.setState({ isLoading: false });
          }
        })
        .catch(error => {
          console.error(error);
          if (error.message.includes("401"))
            window.location =
              window.location.origin +
              "/store/signIn/?redirect=" +
              escape("/atlasUs/pricing?checkoutPlanId=" + planID);
          else this.props.props.handleServerError(true);
        });
    } else {
      if (isFreeTrialSelected) {
        window.location =
          window.location.origin +
          "/store/signUp/?redirect=" +
          escape("/atlasUs/pricing?checkoutPlanId=" + planID);
      } else {
        window.location =
          window.location.origin +
          "/store/signIn/?redirect=" +
          escape("/atlasUs/pricing?checkoutPlanId=" + planID);
      }
    }
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div className="cssload-loader cssload-pricingLoader">
          <div className="cssload-square cssload-square--main">
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
          </div>
        </div>
      );
      // return <div className="loader" />;
    }
    return (
      <div className="row no-gutter">
        <ScrollableAnchor id={"pricingHeader"}>
          <div className="container pricingContainer">
            <h3 className="pricing_mini_title">Skyline Atlas US</h3>
            {this.state.handle_buy_error ? (
              <div id="divWarning" style={{ marginBottom: "30px" }}>
                <button
                  id="x"
                  onClick={event => this.setState({ handle_buy_error: false })}
                >
                  X
                </button>
                {this.state.handle_buy_error_message}
              </div>
            ) : null}
            <div className="row">
              <div className="col-md-4 col-sm-6">
                <div className="pricingTable">
                  <h3 className="title">
                    {intl.get("pricing_plan_Single_User")}
                  </h3>
                  <div className="price-value">
                    <div className="price-value-mount">
                      <span className="amount">
                        <span className="currency">$ {"  "}</span>
                        {this.state.single_user_selected.package_price}{" "}
                      </span>
                      <span style={{ color: "white" }}>
                        {this.state.single_user_selected.package_time ===
                        intl.get("pricing_Yearly")
                          ? " / Year"
                          : " / Month"}
                      </span>
                    </div>
                    <div>
                      <label className="planPeriodLabelClass">
                        {intl.get("pricing_Yearly")}
                      </label>
                      <label className="switch">
                        <input
                          type="checkbox"
                          onChange={this.selectedSingleUserChanged}
                        />
                        <span className="slider round" />
                      </label>
                      <label className="planPeriodLabelClass">
                        {intl.get("pricing_Monthly")}
                      </label>
                      {/* <select
                        className="price-select"
                        onChange={this.selectedSingleUserChanged}
                      >
                        {this.state.single_user_packages.map(packageGroup => {
                          return (
                            <option
                              className="price-option"
                              key={packageGroup.package_id}
                              value={packageGroup.package_price}
                            >
                              {packageGroup.package_time}
                            </option>
                          );
                        })}
                      </select> */}
                    </div>
                    <div className="minimumMonths">
                      <span>
                        {this.state.single_user_selected.package_id === "111" ||
                        this.state.single_user_selected.package_id === "112"
                          ? "minimum 3 months"
                          : null}
                      </span>
                    </div>
                  </div>
                  <ul className="pricing-content text-left">
                    <li className="pricing_package_content">
                      {intl.get("Pricing_Skyline_Atlas_PackageOne_User")}
                    </li>
                    <div className="pricingDivSpace" />
                    <div className="pricing-checkbox custom-checkbox mb-3">
                      <input
                        type="checkbox"
                        defaultChecked={
                          this.state.extenstion_single_User_checkbox
                        }
                        onChange={event =>
                          this.extenstion_single_User_checkbox_changed(event)
                        }
                        className="custom-control-input"
                        id="extenstion_single_User_checkbox"
                      />
                      <label
                        className="custom-control-label customControlLabel"
                        htmlFor="extenstion_single_User_checkbox"
                      >
                        <b>{intl.get("publishing_extension")}</b>
                      </label>
                      <li className="vCheckHidden">
                        {intl.get("publishing_package_single_user_TEP")}
                      </li>
                      <li className="vCheckHidden">
                        {intl.get(
                          "publishing_paclage_single_user_upload_stotrage"
                        )}
                      </li>
                    </div>
                  </ul>
                  <div>
                    {/* <a
                    href="#"
                    className="pricingTable-signup pricingTable-WithFreeTrial"
                  >
                    FREE TRIAL
                  </a> */}
                    <button
                      onClick={event => {
                        if (this.state.single_user_selected.package_id == "109")
                          this.handleBuyNow(event, "123", true);
                        if (this.state.single_user_selected.package_id == "110")
                          this.handleBuyNow(event, "122", true);
                        if (this.state.single_user_selected.package_id == "111")
                          this.handleBuyNow(event, "124", true);
                        if (this.state.single_user_selected.package_id == "112")
                          this.handleBuyNow(event, "125", true);
                      }}
                      className="pricingTable-signup pricingTable-WithFreeTrial"
                    >
                      Free 7-day trial
                    </button>
                    <button
                      onClick={event => {
                        this.handleBuyNow(
                          event,
                          this.state.single_user_selected.package_id
                        );
                      }}
                      className="pricingTable-signup"
                    >
                      {intl.get("pricing_Buy_Now")}
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-6">
                <div className="pricingTable">
                  <h3 className="title">
                    {intl.get("pricing_plan_Small_Buisness")}
                  </h3>
                  <div className="price-value">
                    <div className="price-value-mount">
                      <span className="amount">
                        <span className="currency">$</span>
                        {this.state.small_business_selected.package_price}
                      </span>
                      <span style={{ color: "white" }}>
                        {this.state.small_business_selected.package_time ===
                        intl.get("pricing_Yearly")
                          ? " / Year"
                          : " / Month"}
                      </span>
                    </div>
                    <div>
                      <label className="planPeriodLabelClass">
                        {intl.get("pricing_Yearly")}
                      </label>
                      <label className="switch">
                        <input
                          type="checkbox"
                          onChange={this.selectedSmallBusinessChanged}
                        />
                        <span className="slider round" />
                      </label>
                      <label className="planPeriodLabelClass">
                        {intl.get("pricing_Monthly")}
                      </label>
                      {/* <select
                        className="price-select"
                        onChange={this.selectedSmallBusinessChanged}
                      >
                        {this.state.small_business_packages.map(
                          packageGroup => {
                            return (
                              <option
                                className="price-option"
                                key={packageGroup.package_id}
                                value={packageGroup.package_price}
                              >
                                {packageGroup.package_time}
                              </option>
                            );
                          }
                        )}
                      </select> */}
                    </div>
                    <div className="minimumMonths">
                      <span>
                        {this.state.small_business_selected.package_id ===
                          "115" ||
                        this.state.small_business_selected.package_id === "116"
                          ? "minimum 3 months"
                          : null}
                      </span>
                    </div>
                  </div>
                  <ul className="pricing-content text-left">
                    <li className="pricing_package_content">
                      {intl.get("Pricing_Skyline_Atlas_PackageTwo_User")}
                    </li>
                    <li>{intl.get("publishing_package_small_business_TEP")}</li>
                    <li>
                      {intl.get(
                        "publishing_package_small_business_upload_storage"
                      )}
                    </li>
                    <div className="pricingDivSpace" />
                    <div className="pricing-checkbox custom-checkbox mb-3">
                      <input
                        type="checkbox"
                        defaultChecked={
                          this.state.extension_small_Business_checkbox
                        }
                        onChange={event =>
                          this.extenstion_small_business_checkbox_changed(event)
                        }
                        className="custom-control-input"
                        id="extension_small_Business_checkbox"
                      />
                      <label
                        className="custom-control-label customControlLabel"
                        htmlFor="extension_small_Business_checkbox"
                      >
                        <b>{intl.get("publishing_extension")}</b>
                      </label>
                      <li className="vCheckHidden">
                        {intl.get("publisher_extension_small_business_TEP")}
                      </li>
                      <li className="vCheckHidden">
                        {intl.get(
                          "publisher_extension_small_business_upload_storage"
                        )}
                      </li>
                    </div>
                  </ul>
                  <button
                    onClick={event => {
                      this.handleBuyNow(
                        event,
                        this.state.small_business_selected.package_id
                      );
                    }}
                    className="pricingTable-signup"
                  >
                    {intl.get("pricing_Buy_Now")}
                  </button>
                </div>
              </div>

              <div className="col-md-4 col-sm-6">
                <div className="pricingTable">
                  <h3 className="title">
                    {intl.get("pricing_plan_Enterprise")}
                  </h3>
                  <div className="price-value">
                    <div className="price-value-mount">
                      <span className="amount">
                        <span className="currency">$</span>
                        {this.state.enterpriser_selected.package_price}
                      </span>
                      <span style={{ color: "white" }}>
                        {this.state.enterpriser_selected.package_time ===
                        intl.get("pricing_Yearly")
                          ? " / Year"
                          : " / Month"}
                      </span>
                    </div>
                    <div>
                      <label className="planPeriodLabelClass">
                        {intl.get("pricing_Yearly")}
                      </label>
                      <label className="switch">
                        <input
                          type="checkbox"
                          onChange={this.selectedEnterpriseChanged}
                        />
                        <span className="slider round" />
                      </label>
                      <label className="planPeriodLabelClass">
                        {intl.get("pricing_Monthly")}
                      </label>
                      {/* <select
                        className="price-select"
                        onChange={this.selectedEnterpriseChanged}
                      >
                        {this.state.enterprise_packages.map(packageGroup => {
                          return (
                            <option
                              className="price-option"
                              key={packageGroup.package_id}
                              value={packageGroup.package_price}
                            >
                              {packageGroup.package_time}
                            </option>
                          );
                        })}
                      </select> */}
                    </div>
                    <div className="minimumMonths">
                      <span>
                        {this.state.enterpriser_selected.package_id === "119" ||
                        this.state.enterpriser_selected.package_id === "120"
                          ? "minimum 3 months"
                          : null}
                      </span>
                    </div>
                  </div>
                  <ul className="pricing-content text-left">
                    <li className="pricing_package_content">
                      {intl.get("Pricing_Skyline_Atlas_PackageThree_User")}
                    </li>
                    <li>{intl.get("publishing_package_enterprise_TEP")}</li>
                    <li>
                      {intl.get("publishing_package_enterprise_upload_storage")}
                    </li>
                    <div className="pricingDivSpace" />
                    <div className="pricing-checkbox custom-checkbox mb-3">
                      <input
                        type="checkbox"
                        defaultChecked={
                          this.state.extension_Enterprise_checkbox
                        }
                        onChange={event =>
                          this.extenstion_enterprise_checkbox_changed(event)
                        }
                        className="custom-control-input"
                        id="extension_Enterprise_checkbox"
                      />
                      <label
                        className="custom-control-label customControlLabel"
                        htmlFor="extension_Enterprise_checkbox"
                      >
                        <b>{intl.get("publishing_extension")}</b>
                      </label>
                      <li className="vCheckHidden">
                        {intl.get("publisher_enterprise_business_TEP")}
                      </li>
                      <li className="vCheckHidden">
                        {intl.get(
                          "publisher_extension_enterprise_upload_storage"
                        )}
                      </li>
                    </div>
                  </ul>
                  <button
                    onClick={event => {
                      this.handleBuyNow(
                        event,
                        this.state.enterpriser_selected.package_id
                      );
                    }}
                    className="pricingTable-signup"
                  >
                    {intl.get("pricing_Buy_Now")}
                  </button>
                </div>
              </div>
            </div>
            <div className="FAQ_Pricing">
              <h3>{intl.get("FAQ_What_Is_Skyline_US_Title")}</h3>
              <p>{intl.get("FAQ_What_Is_Skyline_US_Content")}</p>
            </div>
            <div className="FAQ_Pricing">
              <h3>
                {intl.get("FAQ_Can_I_try_out_Skyline_Cloud_for_free_Title")}
              </h3>
              <p>
                {intl.get("FAQ_Can_I_try_out_Skyline_Cloud_for_free_Content")}
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>{intl.get("FAQ_How_To_Publish_Title")}</h3>
              <p>{intl.get("FAQ_How_To_Publish_Content")}</p>
            </div>
            <div className="FAQ_Pricing">
              <h3>{intl.get("FAQ_Which_Package_is_Right_For_Me_Title")}</h3>
              <p>
                {intl.get("FAQ_Which_Package_is_Right_For_Me_Content")}
                <a href="support@skylinesoft.com">support@skylinesoft.com</a>
                {intl.get("FAQ_Which_Package_is_Right_For_Me_Content_1")}
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>{intl.get("FAQ_When_Subscription_End_Title")}</h3>
              <p>{intl.get("FAQ_When_Subscription_End_Content")}</p>
            </div>
            <div className="FAQ_Pricing">
              <h3>{intl.get("FAQ_Upgrade_and_Downgrade_Title")}</h3>
              <p>{intl.get("FAQ_Upgrade_and_Downgrade_Content")}</p>
            </div>
            <div className="FAQ_Pricing">
              <h3>{intl.get("FAQ_Search_For_Skyline_Atlas_Layers_Title")}</h3>
              <p>{intl.get("FAQ_Search_For_Skyline_Atlas_Layers_Content")}</p>
            </div>
            <div className="FAQ_Pricing">
              <h3>{intl.get("FAQ_Which_US_Cities_Included_Title")}</h3>
              <p>{intl.get("FAQ_Which_US_Cities_Included_Content")}</p>
            </div>
            <div className="contact_Us_Pricing">
              <h3>
                {intl.get("FAQ_Contact_US_Title")}{" "}
                <Link
                  to="/contactUs"
                  className="btn btn-outline-primary text-capitalize"
                >
                  {" "}
                  {intl.get("FAQ_Contact_Us")}
                </Link>
              </h3>
            </div>
            <div className="bottom_Spacing" />
          </div>
        </ScrollableAnchor>
      </div>
    );
  }
}

export default Pricing;
